import script from "./integralHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./integralHistory.vue?vue&type=script&setup=true&lang=js"

import "./integralHistory.vue?vue&type=style&index=0&id=8f92e496&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f92e496"]])

export default __exports__